import { ComponentType, Dispatch, SetStateAction, SVGProps, useState } from 'react'
import { useSelector } from 'react-redux'

import arrowIcon from 'assets/svg/burger-arrow.svg'

import { selectors } from 'store/selectors'

import { IActiveMenu } from '@/widgets/burger-menu/ui/burger-menu/burger-menu'
import { NavItem } from '@/widgets/Navigation/NavItem'

import { Nullable } from '@/shared/types/common'
import { TPage, TSection } from '@/shared/types/deprecated-types'
import { Text } from '@/shared/ui'
import { Icon } from '@/shared/ui/icon'

import styles from './NavAccordion.module.scss'

export type NavAccordionProps = {
	navSection: TPage
	setActiveMenu?: Dispatch<SetStateAction<IActiveMenu>>
	closeSideBar?: () => void
	isCatalog?: boolean
	iconId?: ComponentType<SVGProps<SVGSVGElement>>
}

export const NavAccordion = ({
	navSection,
	setActiveMenu,
	closeSideBar,
	isCatalog = false,
	iconId
}: NavAccordionProps): JSX.Element => {
	const { items } = useSelector(selectors.fullCategoriesState)
	const [open, setOpen] = useState(isCatalog)
	const [itemData, setItemData] = useState<TSection>(null)
	const onMouseOver = (ID: string): Nullable<void> => {
		const findParentSection = items.find(item => item.id === ID)

		if (findParentSection) {
			setItemData(findParentSection)
		}
	}

	const onMouseLeave = (): Nullable<void> => {
		// setSubItems(null);
	}

	const iconClassName = [styles.icon]
	if (open) iconClassName.push(styles.icon_open)

	return (
		<details className={styles.navAccordion} open={isCatalog}>
			{/* Accordion title */}
			<summary className={`${styles.summary} js-focus-visible`} onClick={() => setOpen(!open)}>
				<div className={styles.title}>
					{!!iconId && <Icon icon={iconId} width={22} height={22} aria-hidden="true" />}
					<Text as="span">{navSection.title}</Text>
					<div className={iconClassName.join(' ')}>
						<Icon icon={arrowIcon} width={24} height={24} aria-hidden="true" />
					</div>
				</div>
			</summary>
			{/* Nav items */}
			<nav className={styles.items} aria-label={navSection.title}>
				{navSection.items.map(navItem => {
					if (navItem.hidden) {
						return null
					}

					return (
						<NavItem
							{...navItem}
							key={navItem.title}
							setActiveMenu={setActiveMenu}
							closeSideBar={closeSideBar}
							onMouseOver={onMouseOver}
							onMouseLeave={onMouseLeave}
							isActive={itemData && navItem.id === itemData.id}
							prefetch={false}
						/>
					)
				})}
			</nav>
		</details>
	)
}
